import { useMemo, useState } from 'react';
import { inject } from '../ng';
import { Popover, PopoverButton, PopoverPanel } from '../popover/popover';
import { Label } from './label';
import classes from "./header.module.css";
import { offset, shift } from "@floating-ui/react";

const mainAxis = 6;
const crossAxis = -mainAxis;
const panelStyle = {
    maxWidth: `min(300px, calc(100svw - 2 * ${mainAxis}px))`,
    minWidth: `150px`,
    maxHeight: `calc(100svh - var(--header-height) - var(--footer-height) - 2 * ${mainAxis}px)`,
};
const middleware = [offset({ mainAxis, crossAxis }), shift()];

export function MapRegionMenu() {
    const [availableRegions, setAvailableRegions] = useState<string[]>([]);
    const { zoomToRegion } = useMemo(() => {
        const map = inject("mapService").getMap();
        const user = inject('UserProvider').getUser();
        const mapUtilities = inject("mapUtilities");
        setAvailableRegions(user.availableRegions);

        return {
            zoomToRegion(region: string) {
                var data = mapUtilities.getCenterLonLatFromRegion(region);
                var cleanLL = mapUtilities.LLtoMerc(data.lon, data.lat);
                map.setCenter(cleanLL, data.zoom);
            }
        };
    }, []);

    return (
        <Popover placement="bottom-end" strategy="fixed" middleware={middleware}>
                <PopoverButton className={classes.item}>
                    <Label icon="/img/icons/Change_Data_Set.png">Data Regions</Label>
                    <span className="caret"></span>
                </PopoverButton>
                <PopoverPanel style={panelStyle}>
                    {availableRegions.map((region) => (
                        <a className={classes.dataRegion} href="#" onClick={() => zoomToRegion(region)}>
                            {region}
                        </a>
                    ))}
                </PopoverPanel>
            </Popover>
    );
};

export default MapRegionMenu;
